var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a7dcd6ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable-font-preview-wrapper" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-upload" }, null, -1 /* HOISTED */));
const _hoisted_3 = { style: { "margin-left": "10px" } };
import { computed, ref, toRef, toValue, watch, onMounted } from "vue";
import Button from "src/shared/v-components/ui/Button.vue";
import FileUploadZone from "src/shared/v-components/ui/file/FileUploadZone.vue";
import { useCampaignComponentAssetStore } from "src/shared/store/campaign-component-asset";
import { notify } from "src/shared/v-components/ui/notification/notification-service";
import validations from "src/shared/tools/validations/validations";
import { getErrorMessage } from "src/shared/store/common/Exception";
import { useBuiltComponent, useBuiltComponentVariableValue, } from "src/shared/store/component-built/composables";
import _ from "underscore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FontComponentVariableRawValue',
    props: {
        componentId: {},
        variableName: {},
        variant: {},
        modelValue: {},
        isNew: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const campaignComponentAssetStore = useCampaignComponentAssetStore();
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const fontPreviewRef = ref(null);
        const file = ref(null);
        const builtValue = useBuiltComponentVariableValue(toRef(props, "componentId"), toRef(props, "variableName"), toRef(props, "variant"));
        const parseAssetName = (evaluateable) => {
            return evaluateable
                .replace("spel@buildtime:context.getAsset('", "")
                .replace("').getUrl()", "");
        };
        const assetUrl = computed(() => {
            var _a;
            if (!isString(props.modelValue)) {
                return null;
            }
            if (!campaignId.value) {
                return null;
            }
            const assetName = parseAssetName(props.modelValue);
            return (_a = campaignComponentAssetStore
                .getAssetByName(campaignId.value, props.componentId, assetName)) === null || _a === void 0 ? void 0 : _a.getContentUrl();
        });
        const fontValuePreview = computed(() => {
            const assetUrlValue = toValue(assetUrl);
            const builtUrlValue = toValue(builtValue);
            let result = "";
            if (isString(assetUrlValue)) {
                result = assetUrlValue;
            }
            if (isString(builtUrlValue)) {
                result = builtUrlValue;
            }
            if (result === "") {
                return "No font";
            }
            return result;
        });
        const campaignId = computed(() => {
            var _a;
            return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id;
        });
        watch(fontValuePreview, (value) => {
            if (!value || !validations.isUrlValid(value)) {
                return;
            }
            loadFont(replaceNonAlphanumeric(value), value);
        });
        onMounted(() => {
            const fontUrl = fontValuePreview.value;
            if (fontUrl && validations.isUrlValid(fontUrl)) {
                loadFont(replaceNonAlphanumeric(fontUrl), fontUrl);
            }
        });
        function lastPartOfUrl(url) {
            const lastPart = _.last(url.split("/"));
            return lastPart;
        }
        function replaceNonAlphanumeric(str) {
            return str.replace(/[^a-zA-Z0-9]/g, "_");
        }
        function loadFont(name, url) {
            return __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve) => {
                    const myFont = new FontFace(name, `url(${url})`);
                    myFont
                        .load()
                        .then(() => {
                        if (!fontPreviewRef.value) {
                            return;
                        }
                        document.fonts.add(myFont);
                        const el = fontPreviewRef.value;
                        el.style.fontFamily = name;
                        resolve(true);
                    })
                        .catch(() => resolve(false));
                });
            });
        }
        const uploadAssetAndSetValue = () => __awaiter(this, void 0, void 0, function* () {
            if (file.value && campaignId.value) {
                try {
                    const asset = yield campaignComponentAssetStore.saveFile(campaignId.value, props.componentId, file.value);
                    updateValue(asset);
                }
                catch (e) {
                    console.error(e);
                    notify({
                        type: "error",
                        message: getErrorMessage(e),
                    });
                }
            }
        });
        const updateValue = (asset) => {
            if (asset) {
                emit("update:modelValue", `spel@buildtime:context.getAsset('${asset.name}').getUrl()`);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(FileUploadZone, {
                    file: file.value,
                    "onUpdate:file": _cache[0] || (_cache[0] = ($event) => ((file).value = $event)),
                    onFileUploaded: _cache[1] || (_cache[1] = ($event) => (uploadAssetAndSetValue()))
                }, {
                    default: _withCtx(() => [
                        _createVNode(Button, {
                            level: 'tertiary',
                            shape: 'square'
                        }, {
                            default: _withCtx(() => [
                                _hoisted_2
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["file"]),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("b", null, _toDisplayString(lastPartOfUrl(fontValuePreview.value)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                        ref_key: "fontPreviewRef",
                        ref: fontPreviewRef,
                        style: { "margin-left": "10px" }
                    }, " The quick brown fox jumps over the lazy dog. ", 512 /* NEED_PATCH */)
                ])
            ]));
        };
    }
});
